// src/components/MetaTags.js
import React from 'react';
import { Helmet } from 'react-helmet-async'; // Correct import

const MetaTags = ({ title, description, imageUrl, url }) => {
  const defaultTitle = "Acting Auditions in India, Casting Directors, Bollywood - BOOKMYAUDITION";
  const defaultDescription = "Casting directors are searching for talented individuals. BookMyAudition simplifies commercial auditions, connecting actors with opportunities in film, TV, web series, and more.";
  const defaultImageUrl = "https://bookmyaudition.com/theme/theme3/img/social_logo.jpg"; // Replace with your actual deployed image URL later
  const siteUrl = "https://your-deployed-site.com/"; // Replace with your actual deployed URL later

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content="actors, singing, dancing, auditions in mumbai, casting directors, acting auditions, india, bollywood, film, theatre, ad film, web series, ticket2audition, book audition"/>
      <meta name="robots" content="index, follow, all"/>
      <meta name="googlebot" content="index,follow,snippet,archive" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta name="theme-color" content="#b7343a" />

      {/* Open Graph tags */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={imageUrl || defaultImageUrl} />
      <meta property="og:site_name" content="BOOKMYAUDITION"/>
      <meta property="og:image:width" content="601" />
      <meta property="og:image:height" content="376" />
      <meta property="og:image:type" content="image/jpg" />
      {/* <meta property="fb:app_id" content="YOUR_FB_APP_ID" />  Add if you have one */}


      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" /> {/* Use summary_large_image for better display with image */}
      <meta name="twitter:site" content={url || siteUrl} /> {/* Or your @TwitterHandle */}
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={imageUrl || defaultImageUrl} />

    </Helmet>
  );
};

export default MetaTags;